import React, { useEffect, useState } from 'react';
import oikosApi from '../../services/oikos'
import MaterialReactTable from 'material-react-table';
import qs from 'qs';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const MaterialTable = ( { pf_id } ) => {
  const history = useHistory();
  const [ productsOfThePf, setProductsOfThePf ] = useState([])

  const columns = [
    {
      accessorKey: 'proj_nome',
      header: 'Projeto',
      size: 100,
      maxWidth: 200,
      filterVariant: 'text',
      filterFn: 'includesString',
    },
    {
      accessorKey: 'prod_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      filterVariant: 'text',
      filterFn: 'includesString',
    },
    {
      accessorKey: 'prod_responsavelNome',
      header: 'Responsável',
      size: 50,
      filterVariant: 'text',
      filterFn: 'includesString',
    },
    {
      accessorKey: 'prodStatusActual_id',
      header: 'Status',
      accessorFn: (row) => {
        switch (row.prodStatusActual_id) {
          case 2:
            return "Não iniciado"
            return 6
          case 3:
            return "Entregue ao EP"
            return 4
          case 4:
            return "Entregue à Gestão"
            return 3
          case 5:
            return "A entregar p/ Cliente"
            return 2
          case 6:
            return "Entregue ao Cliente"
            return 5
          case 7:
            return "Aprovado pelo Cliente"
            return 7
          case 9:
            return "Em correção"
            return 1
        }
      },
      Cell: ({ cell, row }) => {
        switch (row.original.prodStatusActual_id) {
          case 1:
            return "Não iniciado"
          case 2:
            return "Em Elaboração"
          case 3:
            return "Entregue ao EP"
          case 4:
            return "Entregue à Gestão"
          case 5:
            return "A entregar p/ Cliente"
          case 6:
            return "Entregue ao Cliente"
          case 7:
            return "Aprovado pelo Cliente"
          case 9:
            return "Em correção"
        }
      },
      size: 50,
      filterSelectOptions: [
        'Não iniciado',
        'Em Elaboração',
        'Entregue ao EP',
        'Entregue à Gestão',
        'A entregar p/ Cliente',
        'Entregue ao Cliente',
        'Aprovado pelo Cliente',
        'Em correção',
      ],
      filterVariant: 'multi-select'
    },
    /*
    {
      accessorKey: 'prod_vlr',
      header: 'Valor',
      accessorFn: (row) => row.prod_vlr,
      size: 50,
      sortingFn: 'alphanumeric',
      Cell: ({ cell, row }) => {
        if (row.original.prod_vlr) return currencyFormatter.format(cell.getValue())
      },
      filterVariant: 'range'
    },
    */
    {
      accessorKey: 'prod_dtContrato',
      header: 'Data Contratual',
      accessorFn: (row) => {
        if (row.prod_dtContrato) {
          return (new Date(row.prod_dtContrato)).getTime();
        } else {
          return null;
        }
      },
      size: 30,
      Cell: ({ cell, row }) => {
        if (row.original.prod_dtContrato) {
          return moment(row.original.prod_dtContrato).format('DD/MM/YYYY')
        }
      }, // Format Date for display
      filterVariant: 'range',
      filterFn: 'dateRangeFilterFn',
      sortingFn: 'datetime',
    },
    {
      accessorKey: 'prod_dtInterna',
      header: 'Data Interna',
      accessorFn: (row) => {
        if (row.prod_dtInterna) {
          return (new Date(row.prod_dtInterna)).getTime();
        } else {
          return null;
        }
      },
      size: 30,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.prod_dtInterna) {
          return moment(row.original.prod_dtInterna).format('DD/MM/YYYY')
        }
      }, // Format Date for display
      filterVariant: 'range',
      filterFn: 'dateRangeFilterFn',
    },
    {
      accessorKey: 'prodEntregueAoClienteData',
      header: 'Data Entrega',
      accessorFn: (row) => {
        if (row.prodEntregueAoClienteData) {
          return (new Date(row.prodEntregueAoClienteData)).getTime();
        } else {
          return null;
        }
      },
      size: 30,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.prodEntregueAoClienteData) {
          return moment(row.original.prodEntregueAoClienteData).format('DD/MM/YYYY')
        }
      }, // Format Date for display
      filterVariant: 'range',
      filterFn: 'dateRangeFilterFn',
    },
    {
      accessorKey: 'prodAprovacaoData',
      header: 'Data Aprovação',
      accessorFn: (row) => {
        if (row.prodAprovacaoData) {
          return (new Date(row.prodAprovacaoData)).getTime();
        } else {
          return null;
        }
      },
      size: 30,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.prodAprovacaoData) {
          return moment(row.original.prodAprovacaoData).format('DD/MM/YYYY')
        }
      }, // Format Date for display
      filterVariant: 'range',
      filterFn: 'dateRangeFilterFn',
    },
    {
      accessorKey: 'prod_dtLimAprov',
      header: 'Data Limite Aprovação',
      accessorFn: (row) => {
        if (row.prod_dtLimAprov) {
          return (new Date(row.prod_dtLimAprov)).getTime();
        } else {
          return null;
        }
      },
      size: 30,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.prod_dtLimAprov) {
          return moment(row.original.prod_dtLimAprov).format('DD/MM/YYYY')
        }
      }, // Format Date for display
      filterVariant: 'range',
      filterFn: 'dateRangeFilterFn',
    },
  ]

  const preloading = async () => {
    if (!pf_id) return;

    const produtos = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        prod_ativo: 1,
        prod_responsavel: pf_id,
      },
      fields: {
        "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
        "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
          "prodStatusTp_nome",
        "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
          "prodStatusActual_id",
        "(SELECT proj.proj_situacao FROM proj WHERE proj.proj_id = prod.proj_id AND proj.proj_ativo = 1)":
          "proj_situacao",
        "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)":
          "proj_nome",
        "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
          "prodEntregueAoClienteData",
        "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
          "prodAprovacaoData",
      },
    })}`);

    console.log(produtos)

    const produtosEmAndamento = (produtos.data).filter((produto) => produto.proj_situacao === 3 && produto.prodStatusActual_id !== 7);
    setProductsOfThePf(produtosEmAndamento);
  }

  useEffect(() => {
    preloading();
  }, [])

  if (productsOfThePf.length === 0) {
    return (
      <></>
    )
  }

  return (
    <MaterialReactTable
      columns={columns}
      data={productsOfThePf}
      initialState={{
        density: 'compact',
        expanded: {}, //expand all groups by default
        pagination: { pageIndex: 0, pageSize: 500 },
        sorting: [{ id: 'prodStatusActual_id', desc: false }],
      }}
      filterFns={{
        dateRangeFilterFn: (row, id, filterValue) => {

          if (!filterValue || !filterValue[0] || !filterValue[1]) {
            return true; // Return true to show all rows if the filter is cleared
          }

          return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
        },
      }}
      enableFacetedValues
      enableGrouping
      enableGlobalFilter={true}
      enableFilters={true}
      enablePagination={true}
      muiTopToolbarProps={{sx: {
        '.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"},
        '.MuiSvgIcon-root': {width: '12px'},
        '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
        '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
        '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
      }}}

      muiTableBodyCellProps={{sx: {fontSize: "13px", whiteSpace: 'normal', overflowWrap: 'break-word', maxWidth: "300px"}}}

      muiTablePaginationProps={{
      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
      labelRowsPerPage: <span style={{fontSize: "12px"}}>Projetos por página</span>,
      rowsPerPageOptions: [500, 2000],
      }}
      positionPagination='bottom'
      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
      enableDensityToggle={false}
      enableColumnFilters={true}
      muiTableHeadCellProps={{
        sx: {
          fontSize: '12px',
          fontWeight: 'normal', // Remove bold text in the header
          padding: '8px', // Adjust padding to reduce white space
        },
      }}

      muiTableBodyRowProps={({ row }) => ({
        onClick: () => {
          const project = row.original;
          history.push({
            pathname: `/dep-tecnico/projetos/${project.proj_id}`,
            project,
          })
        },
        sx: { cursor: 'pointer' },
      })}

      muiTableHeadCellFilterTextFieldProps={{
        sx: {
        color: "red",
        }
      }}
    />
  );
};

export default MaterialTable;
